export const OPPORTUNITY_STAGE_COLORS: Record<string, string> = {
  'Offerteaanvraag': 'bg-blue-100 text-blue-700',
  'Doorverwezen': 'bg-indigo-100 text-indigo-700',
  'Werk Order aangemaakt': 'bg-emerald-100 text-emerald-700',
  'Opdracht': 'bg-emerald-100 text-emerald-700',
  'Offerte verloren': 'bg-slate-100 text-slate-500',
  'Niet gereageerd: Open': 'bg-amber-100 text-amber-700',
};

export const OPPORTUNITY_TYPE_COLORS: Record<string, string> = {
  'Offerte Extern': 'bg-violet-100 text-violet-700',
  'Opdracht Extern': 'bg-teal-100 text-teal-700',
  'Opdracht Intern': 'bg-slate-100 text-slate-600',
};

export type OpportunityStageGroup = 'all' | 'open' | 'won' | 'lost';

export const OPPORTUNITY_STAGE_GROUPS: Record<OpportunityStageGroup, { label: string; stages: string[] }> = {
  all: { label: 'Alle', stages: [] },
  open: {
    label: 'Open',
    stages: ['Offerteaanvraag', 'Doorverwezen', 'Niet gereageerd: Open'],
  },
  won: {
    label: 'Gewonnen',
    stages: ['Werk Order aangemaakt', 'Opdracht'],
  },
  lost: {
    label: 'Verloren',
    stages: ['Offerte verloren'],
  },
};

export const SALESFORCE_OPP_URL = (oppId: string) =>
  `https://cinco.my.salesforce.com/${oppId}`;
